export default () => ({
  recomendedPosts: [],
  //forYouPosts: [],
  suggestedPosts: [],
  recomendedPost: [],
  followingPosts: [],
  replies: [],
  reputationCategories: null,
  post: null,
  now: new Date(),
  profile: null,
  userReplies: [],
  userReposts: [],
  onlyUserPosts: [],
  loadStatus: false,
  reportId: null,
  isReply: false,
  replyPostStatus: [],
  totalCountPosts: null,
  allFollowPosts: [],
  repliesCount: 0,
  searchText: '',
  searchResults: {
    users: [],
    posts: [],
  },
  unreadPosts: [],
  noSearchResults: null,
});
